import Vue from 'vue'
import store from '@/store'

function checkCustomerType (customerTypes, customerTypeId) {
  const findCustomerType = customerTypes?.find(
    (customerType) => customerTypeId === customerType.value
  )
  return findCustomerType ? findCustomerType.text : 'บุคคลธรรมดา'
}

export default async (to, from, next) => {
  const vm = new Vue()
  const activeLineOfficialAccount = store.getters['User/activeLineOfficialAccount']

  if (store.getters['CustomerType/isCustomerTypesEmpty']) {
    store.dispatch('wait/start', 'app loading', { root: true })
    await store.dispatch('CustomerType/fetchCustomerTypes')
    store.dispatch('wait/end', 'app loading', { root: true })
  }

  const customerTypes = store.getters['CustomerType/customerTypes']
  const customerTypeName = checkCustomerType(customerTypes, activeLineOfficialAccount.customerTypeId)
  if (customerTypeName === 'บุคคลธรรมดา') {
    const res = await vm.$swal({
      icon: 'warning',
      title: 'ไม่สามารถใช้บริการนี้ได้',
      html: 'บริการตัวแทนจัดการภาษี ณ ที่จ่าย เปิดให้เฉพาะ<br>ลูกค้านิติบุคคลเท่านั้น หากคุณเปลี่ยนรูปแบบธุรกิจแล้ว<br>สามารถไปอัปเดตข้อมูลได้ที่หน้า "ข้อมูลลูกค้า"<br>ก่อนดำเนินการ',
      showCancelButton: true,
      showCloseButton: true,
      reverseButtons: true,
      cancelButtonText: 'ยกเลิก',
      cancelButtonColor: '#E5E7EB',
      confirmButtonText: 'ข้อมูลลูกค้า',
      customClass: {
        cancelButton: 'swal2-cancel-gray'
      }
    })
    if (res.isConfirmed) {
      next({ name: 'Profile' })
    }

    return
  }

  next()
}
